import Cookies from "js-cookie";
import { useFetchData } from "../utils/ReactQueryHooks";
import { isData } from "utils/HookResponse";
import { ApiResponseData } from "types/common";

export const useFirewareVersions = (deviceCode: string) =>
  useFetchData({
    key: "firewareVersions",
    url: "firmwares/versions",
    headers: {
      aid: Cookies.get("aId"),
      "device-code": deviceCode,
    },
    options: {
      enabled: false,
      select: (data: ApiResponseData) => [...new Set(isData(data))],
    },
  });
